/* hgn-side-cart-kit-ready.js — the "kit-ready moment" in the side cart (20–21 Oct 2026).
   Spec: redesigned/KIT-READY-SPEC-2026-10-20.md §2–§6. Bet 2 (bigger baskets through kits);
   measure: completed kits bought within 24 h, by arm. Matt: "it's in the bag, here's what you've
   got, now checkout."
   Arm family `kitready` (registered by hgn-side-cart-attach.js; announcement setting "Kit-ready
   moment arm" → HGN_SIDE_CART_CONFIG.attach.kitReadyArm, ships `off`; QA ?hgn_kitready=A|B).
   Arm A: today's drawer byte for byte — this file only notes landings (the both-arm `eligible`).
   Arm B, a saved kit in the bag: the hero card for the newest kit (rail + thumbs + quick view +
   swap, "What's inside" receipt from the bag's own maths, the kit-price row, gift colour, Remove
   kit), one composed bag ("Also in your bag"), the pinned pay foot (express first; a wallet tap is
   HGN.express.openFrom('kitready')), and the Reveal on a bundle's first show (below).
   Events: hgn:offer:kitready_<name> (snippets/hgn-arm-beacon.liquid). Contract: hgn:kit:finalised
   { tier, how, edit, bundleId, gesture } picks the hero; else the newest `_bundle_id`.
   ES5 on purpose (Shopify's asset minifier). Hooks: window.__hgnSideCartBridge. */
(function () {
  'use strict';
  var B = window.__hgnSideCartBridge;
  if (!B || !B.HGNSideCart) return;
  var P = B.HGNSideCart.prototype;
  if (P.__hgnKitReadyLoaded) return;
  P.__hgnKitReadyLoaded = true;
  var H = B.helpers || {};
  window.HGN = window.HGN || {};

  var FRESH_MS = 3 * 60 * 1000;            /* a bundle first seen this young counts as a landing */
  var QA_PARAM = 'hgn_kitready';
  var QA_KEY = 'hgn_arm_qa_kitready';      /* the attach registry's own per-tab pin key */
  var SEEN_KEY = 'hgn_kitready_seen';      /* localStorage { bundleId: { at, tier, how, edit } } */
  var LAST_KEY = 'hgn_kitready_last';      /* localStorage the newest hgn:kit:finalised */
  var ORDER_KEY = 'hgn_kitready_order';    /* sessionStorage { bundleId: [variantId…] } rail order */
  var TIER_NAME = { classic: 'Classic', gels: 'Gel', 'press-ons': 'Press-On' };
  var SLOT_NAME = { topCoat: 'top coat', uvLamp: 'LED lamp', remover: 'remover', giftBag: 'gift bag', magicRemover: 'Magic Remover', tabs: 'nail tabs', glue: 'nail glue' };
  var REQUIRED_SLOTS = { topCoat: 1, uvLamp: 1, remover: 1, giftBag: 1 };
  var BEST_SLUG = { classic: 'bestsellers-edit-classic', gels: 'bestsellers-edit-gels', 'press-ons': 'bestsellers-edit-pressons' };

  var esc = H.escapeHtml || function (s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  };
  function money(cents, cur) { return typeof H.formatMoney === 'function' ? H.formatMoney(cents, cur) : '£' + ((cents || 0) / 100).toFixed(2); }
  function A() { return B.attach || {}; }
  function lsGet(k) { try { return JSON.parse(localStorage.getItem(k) || 'null'); } catch (e) { return null; } }
  function lsSet(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  function ssGet(k) { try { return JSON.parse(sessionStorage.getItem(k) || 'null'); } catch (e) { return null; } }
  function ssSet(k, v) { try { sessionStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  function warn(e) { try { if (window.console && console.warn) console.warn('[hgn-side-cart-kit-ready]', e); } catch (x) {} }
  function reducedMotion() { try { return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) { return false; } }

  /* ── Arm ──────────────────────────────────────────────────────────────
     The registry (attach file) owns assignment. `off` = the merchant setting is off (or absent)
     and no QA pin: everyone sees today's drawer and the beacon skips the family. */
  (function readQa() {
    try {
      var q = new URLSearchParams(location.search).get(QA_PARAM);
      if (q == null) return;
      q = String(q).toUpperCase();
      if (q === 'A' || q === 'B') sessionStorage.setItem(QA_KEY, q);
      else sessionStorage.removeItem(QA_KEY);
    } catch (e) {}
  })();
  function qaPin() { try { var q = sessionStorage.getItem(QA_KEY); return q === 'A' || q === 'B' ? q : null; } catch (e) { return null; } }
  function off() {
    if (qaPin()) return false;
    try {
      var v = window.HGN_SIDE_CART_CONFIG && window.HGN_SIDE_CART_CONFIG.attach && window.HGN_SIDE_CART_CONFIG.attach.kitReadyArm;
      return v == null || v === '' || String(v) === 'off';
    } catch (e) { return true; }
  }
  function arm() {
    if (off()) return 'A';
    try {
      if (typeof window.HGN.armFor !== 'function') return 'A';
      return window.HGN.armFor('kitready') === 'B' ? 'B' : 'A';
    } catch (e) { return 'A'; }
  }
  function isB() { return arm() === 'B'; }

  /* Events: hgn:offer:kitready_<name>. The beacon reads tier / reason / surface only, so `how`,
     `n` and `wallet` ride as `reason` and the edit slug as `surface` (see hgn-arm-beacon). */
  function offer(name, detail) {
    if (off()) return;   /* switched off: no event, no Clarity tag (21 Oct: off writes nothing) */
    try { document.dispatchEvent(new CustomEvent('hgn:offer:kitready_' + name, { detail: detail || {} })); } catch (e) {}
    try { if (typeof window.clarity === 'function') window.clarity('set', 'hgn_kitready_' + name, String((detail && (detail.reason || detail.tier)) || '1')); } catch (e) {}
  }
  var onceKeys = {};
  function offerOnce(key, name, detail) { if (onceKeys[key]) return; onceKeys[key] = 1; offer(name, detail); }

  /* ── Landings (both arms) ──────────────────────────────────────────── */
  function bundleTs(bid) { var m = /^box-(\d{12,14})/.exec(String(bid || '')); return m ? parseInt(m[1], 10) : 0; }
  function readSeen() { var s = lsGet(SEEN_KEY); return s && typeof s === 'object' ? s : {}; }
  function writeSeen(s) {
    var keys = Object.keys(s);
    if (keys.length > 12) {
      keys.sort(function (a, b) { return (s[a].at || 0) - (s[b].at || 0); });
      keys.slice(0, keys.length - 12).forEach(function (k) { delete s[k]; });
    }
    lsSet(SEEN_KEY, s);
  }
  var pending = null;   /* a finalise without a bundle id: matched to the next fresh bundle of its tier */
  function landed(rec) {
    offer('eligible', { tier: rec.tier || '', how: rec.how || 'unknown', edit: rec.edit || null, reason: rec.how || 'unknown', surface: rec.edit || '' });
  }
  document.addEventListener('hgn:kit:finalised', function (e) {
    try {
      if (off()) return;   /* switched off: no landing record */
      var d = (e && e.detail) || {};
      var rec = { bundleId: d.bundleId || null, tier: d.tier || '', how: d.how || 'unknown', edit: d.edit || null, gesture: !!d.gesture, at: Date.now() };
      lsSet(LAST_KEY, rec);
      if (rec.bundleId) {
        var seen = readSeen();
        if (seen[rec.bundleId]) return;
        seen[rec.bundleId] = { at: rec.at, tier: rec.tier, how: rec.how, edit: rec.edit };
        writeSeen(seen);
      } else {
        pending = rec;
      }
      landed(rec);
    } catch (x) {}
  });
  /* Every render: a bundle id not seen before is a landing when it is fresh (or matches a
     finalise that carried no id); an old one (a kit from before this file) is noted silently. */
  function noteBundles(bundles) {
    if (off()) return readSeen();   /* switched off: read only, nothing written */
    var seen = readSeen(), dirty = false, now = Date.now();
    bundles.forEach(function (b) {
      if (!b.id || seen[b.id]) return;
      var ts = bundleTs(b.id);
      var edit = b.edit ? b.edit.slug || null : null;
      if (pending && pending.tier === b.tier && now - pending.at < 2 * 60 * 1000) {
        seen[b.id] = { at: pending.at, tier: b.tier, how: pending.how, edit: pending.edit || edit };
        pending = null;
      } else if (ts && now - ts < FRESH_MS) {
        seen[b.id] = { at: ts, tier: b.tier, how: 'unknown', edit: edit };
        landed({ tier: b.tier, how: 'unknown', edit: edit });
      } else {
        seen[b.id] = { at: ts || 0, tier: b.tier, how: 'old', edit: edit };
      }
      dirty = true;
    });
    if (dirty) writeSeen(seen);
    return seen;
  }

  /* ── Bag model ─────────────────────────────────────────────────────── */
  function accSlotMap(tier) {
    var broadcast = (window.HGN_KIT_ACCESSORIES || {})[tier] || {};
    var map = {};
    Object.keys(broadcast).forEach(function (slot) {
      (broadcast[slot] || []).forEach(function (o) {
        if (!o) return;
        if (o.variantId != null) map['v:' + o.variantId] = slot;
        if (o.handle) map['h:' + o.handle] = slot;
      });
    });
    return map;
  }
  function slotOf(map, it) { return map['v:' + it.variant_id] || map['h:' + it.handle] || null; }
  function unitRetail(it) {
    if (typeof H.lineOneUnitRetailCents === 'function') return H.lineOneUnitRetailCents(it);
    return it.original_price != null ? it.original_price : Math.round((it.original_line_price || it.line_price || 0) / Math.max(1, it.quantity || 1));
  }
  function thumb(src, w) { return typeof H.thumbUrl === 'function' ? H.thumbUrl(src, w) : src; }
  /* The collection card's name (attach cardName: "Blush - Holy Classics (…)" → "Blush"), less a
     finish spec the card shows on its own line ("French Manicure (Part Transparent)"). */
  function cardName(t) {
    var f = A().cardName;
    var n = typeof f === 'function' ? f(t) : String(t || '').split(' - ')[0];
    return String(n).replace(/\s*\((part transparent|transparent|semi[- ]?cured)\)\s*$/i, '') || n;
  }
  function accName(t) {
    var s = String(t || '').replace(/\s*[-–—]\s*holy grail nail\s*$/i, '').replace(/^\s*holy grail nail\s*[-–—]?\s*/i, '').trim();
    return s.replace(/\s+-\s+/g, ' · ') || String(t || '');
  }
  function kit5Cents(inst) {
    try {
      if (typeof inst._kit5FoldGbpCents !== 'function' || typeof H.gbpToActiveCents !== 'function') return 0;
      return H.gbpToActiveCents((inst._kit5FoldGbpCents({ display: true }) || 0) / 100) || 0;
    } catch (e) { return 0; }
  }
  /* The bag's own deal for a bundle — renderBundleCard's maths, kit5 on the first saved card. */
  function dealOf(inst, groups, bundle) {
    if (bundle.gbpPaidCents == null) return { retail: bundle.retailCents || 0, paid: bundle.paidCents || bundle.retailCents || 0, save: 0 };
    var k5 = 0;
    for (var i = 0; i < groups.bundles.length; i++) {
      if (groups.bundles[i].gbpPaidCents == null) continue;
      if (groups.bundles[i] === bundle) k5 = kit5Cents(inst);
      break;
    }
    var save = (typeof H.bundleSavingsPresentmentCents === 'function' ? H.bundleSavingsPresentmentCents(bundle) : 0) + k5;
    return { retail: bundle.retailCents || 0, paid: Math.max(0, (bundle.retailCents || 0) - save), save: save };
  }
  /* Designs in a stable order: a swapped design keeps its place in the rail even though
     Shopify puts the new line first. */
  function orderedLines(bundle) {
    var view = typeof H.kitLinesForView === 'function' ? H.kitLinesForView(bundle) : bundle.items.slice();
    var map = accSlotMap(bundle.tier);
    var designs = [], extras = [];
    view.forEach(function (it) { (slotOf(map, it) ? extras : designs).push(it); });
    var all = ssGet(ORDER_KEY) || {};
    var order = all[bundle.id] || [];
    var known = designs.filter(function (it) { return order.indexOf(String(it.variant_id)) !== -1; });
    var fresh = designs.filter(function (it) { return order.indexOf(String(it.variant_id)) === -1; });
    known.sort(function (a, b) { return order.indexOf(String(a.variant_id)) - order.indexOf(String(b.variant_id)); });
    designs = known.concat(fresh);
    var next = designs.map(function (it) { return String(it.variant_id); });
    if (next.join(',') !== order.join(',')) { all[bundle.id] = next; ssSet(ORDER_KEY, all); }
    return { designs: designs, extras: extras.map(function (it) { return { it: it, slot: slotOf(map, it) }; }) };
  }
  function replaceInOrder(bid, oldVid, newVid, keepOld) {
    var all = ssGet(ORDER_KEY) || {};
    var o = all[bid] || [];
    var i = o.indexOf(String(oldVid));
    if (i === -1) return;
    if (keepOld) o.splice(i + 1, 0, String(newVid)); else o[i] = String(newVid);
    all[bid] = o;
    ssSet(ORDER_KEY, all);
  }
  function intentNailPoints(inst) {
    try { if (typeof inst._isNailPointsActive === 'function') return inst._isNailPointsActive(); } catch (e) {}
    try { return inst._getDiscountIntent() === 'nailpoints'; } catch (e2) { return false; }
  }

  /* The hero: the bundle the newest hgn:kit:finalised named, else the newest landing. */
  function pickHero(inst) {
    var cart = inst.cart;
    if (!cart || !cart.item_count || typeof H.groupCartLines !== 'function') return null;
    var groups = H.groupCartLines((cart.items || []).slice());
    var kits = groups.bundles.filter(function (b) { return b.tier && b.items.length; });
    var seen = noteBundles(kits);
    if (!kits.length || intentNailPoints(inst)) return null;
    var last = lsGet(LAST_KEY) || {};
    var pick = null;
    if (last.bundleId) kits.forEach(function (b) { if (b.id === last.bundleId) pick = b; });
    var whenOf = function (b) { var s = seen[b.id]; return Math.max((s && s.at) || 0, bundleTs(b.id)); };
    if (!pick) kits.forEach(function (b) { if (!pick || whenOf(b) >= whenOf(pick)) pick = b; });
    var rec = seen[pick.id] || {};
    var lines = orderedLines(pick);
    return {
      bundle: pick, groups: groups, cart: cart, cur: cart.currency, tier: pick.tier,
      edit: pick.edit, how: rec.how || 'unknown',
      designs: lines.designs, extras: lines.extras, deal: dealOf(inst, groups, pick),
      gift: typeof H.bundleGiftSwap === 'function' ? H.bundleGiftSwap(pick) : null,
      skin: pick.edit && (pick.edit.skin === 'halloween' || pick.edit.skin === 'christmas') ? pick.edit.skin : 'brand'
    };
  }

  /* ── Markup ────────────────────────────────────────────────────────── */
  var CHECK = '<svg viewBox="0 0 12 12" fill="none" aria-hidden="true" focusable="false"><path d="M2 6.5l2.5 2.5L10 3.5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var SWAP_ICON = '<svg viewBox="0 0 16 16" fill="none" aria-hidden="true" focusable="false"><path d="M13 8a5 5 0 1 1-1.6-3.7" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/><path d="M11.8 1.6v3.1H8.7" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var PLUS = '<svg viewBox="0 0 16 16" fill="none" aria-hidden="true" focusable="false"><path d="M8 3v10M3 8h10" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>';
  function bagWord() {
    var t = String((window.HGN_COPY || {}).cart_title || 'Your Bag').replace(/^your\s+/i, '');
    return t ? t.toLowerCase() : 'bag';
  }
  function heroName(h) { return h.edit && h.edit.title ? h.edit.title : 'Your ' + (TIER_NAME[h.tier] || '') + ' Starter Kit'; }
  /* With the receipt showing, it says what's inside: the sub keeps only the tier under an edit's name. */
  function units(list) { return list.reduce(function (a, it) { return a + (it.quantity || 1); }, 0); }
  function heroSub(h) {
    if (rcptRows(h)) return h.edit && h.edit.title ? (TIER_NAME[h.tier] || '') + ' Starter Kit' : '';
    var n = units(h.designs);
    var acc = [];
    h.extras.forEach(function (x) { var w = SLOT_NAME[x.slot]; if (w && acc.indexOf(w) === -1) acc.push(w); });
    var tail = acc.length ? ' + ' + acc.join(' + ') : '';
    if (h.edit && h.edit.title) return (TIER_NAME[h.tier] || '') + ' Starter Kit · ' + n + ' designs' + tail;
    return n + ' design' + (n === 1 ? '' : 's') + ' you picked' + tail;
  }
  function itemsCount(h) { return h.bundle.items.reduce(function (s, it) { return s + (it.quantity || 1); }, 0); }
  function collageHtml(h) {
    if (typeof H.bundleCollageMarkup !== 'function') return '';
    /* Hand-built kits wear the brand collage, never the page's seasonal skin. */
    var b = {};
    for (var k in h.bundle) if (Object.prototype.hasOwnProperty.call(h.bundle, k)) b[k] = h.bundle[k];
    if (!b.edit) b.edit = { title: '', slug: '', skin: 'brand' };
    return H.bundleCollageMarkup(b);
  }
  /* Quick view (Matt, 21 Oct: "add quick view to the kit items and the swaps"): our own ⓘ and image
     taps open HGN.quickView with the kit's options (onSwap / price / action). They carry neither
     .hgn-qv-trigger nor data-hgn-qv-handle — the quick view's capture listener owns those and would
     open a plain view instead. Same drawn trigger: 26 px circle, the same glyph, 44 px target. */
  var QV_I = '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false"><circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="1.6"/><path d="M12 11v5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/><circle cx="12" cy="8" r="1" fill="currentColor"/></svg>';
  function qvBtn(spec, name, extra) { return '<button type="button" class="hgn-kr__qvi hgn-kr__qvi--media' + (extra || '') + '" data-kr-qv="' + spec + '" aria-label="Quick view: ' + esc(name) + '">' + QV_I + '</button>'; }
  function sized(src, w) { return esc(thumb(src, w)); }
  function srcset(src, ws) { return ws.map(function (w) { return sized(src, w) + ' ' + w + 'w'; }).join(', '); }
  /* The rail: the collage, each design (image + "Name · worth £x" — no piece counts, Matt 21 Oct), then
     each accessory on white. Captions show on the active slide only (the peek is a clean image).
     Thumbnails mirror it under the rail. Images: a DPR 2–3 srcset off the CDN width param; the
     collage loads eager at fetchpriority high. */
  function railHtml(h, state) {
    var cur = h.cur, n = h.designs.length, tier = h.tier;
    var unit = tier === 'press-ons' ? 'Set' : 'Design';
    var slides = [], thumbs = [];
    var CHEV = '<svg viewBox="0 0 12 12" fill="none" aria-hidden="true" focusable="false"><path d="M4.5 2.5 8 6l-3.5 3.5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    slides.push(
      '<div class="hgn-kr__slide hgn-kr__slide--collage is-active" data-kr-slide="0" role="group" aria-roledescription="slide" aria-label="Your kit">' +
        '<button type="button" class="hgn-kr__media hgn-kr__media--collage" data-kr-next aria-label="See what’s in your kit">' +
          collageHtml(h).replace(/loading="lazy"/g, 'loading="eager" fetchpriority="high"') + '<span class="hgn-kr__sheen" aria-hidden="true"></span></button>' +
        '<span class="hgn-kr__tag">Swipe to see all ' + itemsCount(h) + CHEV + '</span>' +
        /* the same ↻ Swap as each design (cold audit 21 Oct): it moves to the first design and opens its strip */
        (firstSwappable(h) ? '<button type="button" class="hgn-kr__swap-pill" data-kr-swap-first aria-label="Swap a design">' + SWAP_ICON + '<span>Swap</span></button>' : '') +
      '</div>');
    var mosaic = h.designs.concat(h.extras.map(function (x) { return x.it; })).filter(function (it) { return it.image; }).slice(0, 4);
    thumbs.push('<button type="button" class="hgn-kr__thumb hgn-kr__thumb--kit is-on" data-kr-thumb="0" aria-label="Your kit"><span class="hgn-kr__mosaic">' +
      mosaic.map(function (it) { return '<img src="' + sized(it.image, 80) + '" alt="" loading="lazy" decoding="async">'; }).join('') + '</span></button>');
    h.designs.forEach(function (it, i) {
      var name = cardName(it.product_title || it.title);
      var swapped = state.swapFx && state.swapFx.vid === String(it.variant_id);
      var morph = swapped && state.swapFx.vt;
      if (morph) swapped = false;
      slides.push(
        '<div class="hgn-kr__slide' + (swapped ? ' is-swapped' : '') + '" data-kr-slide="' + (i + 1) + '" data-kr-key="' + esc(it.key) + '" role="group" aria-roledescription="slide" aria-label="' + unit + ' ' + (i + 1) + ' of ' + n + '">' +
          '<button type="button" class="hgn-kr__media" data-kr-qv="kit:' + i + '" aria-label="Quick view: ' + esc(name) + '"' + (morph ? ' style="view-transition-name:kr-swap"' : '') + '>' +
            (it.image ? '<img src="' + sized(it.image, 600) + '" srcset="' + srcset(it.image, [400, 600, 900]) + '" sizes="(max-width: 600px) 75vw, 300px" alt="" loading="lazy" decoding="async">' : '') +
            '<span class="hgn-kr__cap"><span class="hgn-kr__cap-n">' + esc(name) + '</span><span class="hgn-kr__cap-w">worth ' + money(unitRetail(it), cur) + '</span></span>' +
          '</button>' + qvBtn('kit:' + i, name) +
          (swappable(it) ? '<button type="button" class="hgn-kr__swap-pill' + (state.swap && state.swap.key === it.key ? ' is-on' : '') + '" data-kr-swap="' + esc(it.key) + '" aria-label="Swap ' + esc(name) + '" aria-expanded="' + (state.swap && state.swap.key === it.key ? 'true' : 'false') + '">' + SWAP_ICON + '<span>Swap</span></button>' : '') +
        '</div>');
      thumbs.push('<button type="button" class="hgn-kr__thumb" data-kr-thumb="' + (i + 1) + '" aria-label="' + esc(name) + '">' + (it.image ? '<img src="' + sized(it.image, 132) + '" alt="" loading="lazy" decoding="async">' : '') + '</button>');
    });
    h.extras.forEach(function (x, j) {
      var it = x.it;
      var label = SLOT_NAME[x.slot] || 'extra';
      label = label.charAt(0).toUpperCase() + label.slice(1);
      slides.push(
        '<div class="hgn-kr__slide hgn-kr__slide--acc" data-kr-slide="' + (n + 1 + j) + '" role="group" aria-roledescription="slide" aria-label="' + esc(label) + '">' +
          '<button type="button" class="hgn-kr__media hgn-kr__media--acc" data-kr-qv="acc:' + j + '" aria-label="Quick view: ' + esc(accName(it.product_title || it.title)) + '">' +
            (it.image ? '<img src="' + sized(it.image, 600) + '" srcset="' + srcset(it.image, [400, 600, 900]) + '" sizes="(max-width: 600px) 75vw, 300px" alt="" loading="lazy" decoding="async">' : '') +
            '<span class="hgn-kr__cap"><span class="hgn-kr__cap-n">' + esc(accName(it.product_title || it.title)) + '</span><span class="hgn-kr__cap-k">' + esc(label) + ' · ' + (REQUIRED_SLOTS[x.slot] ? 'included' : 'added') + '</span><span class="hgn-kr__cap-w">worth ' + money(unitRetail(it), cur) + '</span></span>' +
          '</button>' + qvBtn('acc:' + j, accName(it.product_title || it.title)) +
        '</div>');
      thumbs.push('<button type="button" class="hgn-kr__thumb hgn-kr__thumb--acc" data-kr-thumb="' + (n + 1 + j) + '" aria-label="' + esc(label) + '">' + (it.image ? '<img src="' + sized(it.image, 132) + '" alt="" loading="lazy" decoding="async">' : '') + '</button>');
    });
    return { rail: slides.join(''), thumbs: thumbs.join(''), count: slides.length };
  }
  /* "What's inside" — the receipt that proves the deal (replaces the price block, 21 Oct).
     Rows are the kit's own cart lines at their live line prices: the designs summed, then each
     accessory. They add up to the bundle's retail (the bag's retailCents) by construction, and
     "Your kit" is retail − the bag's saving (bundleSavingsPresentmentCents + the kit5 fold) — the
     figure the card has always shown. Should the rows ever not add up, only the kit line shows:
     never a sum that doesn't reconcile. No strike-through anywhere (KIT-BUILD.md, Matt 14 Sep). */
  function lineRetail(it) { return it.original_line_price != null ? it.original_line_price : (it.line_price || 0); }
  function receiptRows(h) {
    var dz = 0;
    h.designs.forEach(function (it) { dz += lineRetail(it); });
    var rows = [{ k: units(h.designs) + ' ' + (h.tier === 'press-ons' ? 'press-on sets' : (h.tier === 'gels' ? 'gel designs' : 'designs')) + (h.edit && h.edit.title ? '' : ' you picked'), v: dz }];
    h.extras.forEach(function (x) { rows.push({ k: x.slot === 'giftBag' ? 'Gift bag' : accName(x.it.product_title || x.it.title), v: lineRetail(x.it) }); });
    return rows;
  }
  /* The rows, only when they add up to the bag's retail and there is a saving; else null. */
  function rcptRows(h) {
    var rows = receiptRows(h);
    var sum = rows.reduce(function (a, r) { return a + r.v; }, 0);
    return h.deal.save > 0 && sum === h.deal.retail ? rows : null;
  }
  function receiptHtml(h) {
    var d = h.deal, cur = h.cur;
    var num = function (c) { return '<span class="hgn-kr__num" data-kr-num="' + c + '">' + money(c, cur) + '</span>'; };
    var kit = '<div class="hgn-kr__rc-kit"><span class="hgn-kr__rc-kit-l">Your kit</span><span class="hgn-kr__price">' + money(d.paid, cur) + '</span>' +
      (d.save > 0 ? '<span class="hgn-kr__save">You save ' + num(d.save) + '</span>' : '') + '</div>';
    var rows = rcptRows(h);
    var tail = kit;
    if (!rows) return tail;
    return '<p class="hgn-kr__rc-h">What’s inside</p><ul class="hgn-kr__rc-rows">' +
      rows.map(function (r, i) { return '<li class="hgn-kr__rc-row" style="--i:' + i + '"><span>' + esc(r.k) + '</span><i aria-hidden="true"></i>' + num(r.v) + '</li>'; }).join('') +
      '</ul><p class="hgn-kr__rc-total" style="--i:' + rows.length + '"><span>If bought separately</span>' + num(d.retail) + '</p>' + tail;
  }
  /* No perks row (Matt, 21 Oct): "Swap designs before you pay" — the ↻ Swap on each slide is the
     affordance; "Free UK delivery" — the drawer's meter and the bag total already say it. */
  /* The hero owns its kit (Matt, 21 Oct): its gift-bag colour and "Remove kit" are the saved-kit
     card's own controls, moved here and wired to the same core handlers (_swapBundleGift,
     _removeBundle and its three-way confirm), so behaviour is unchanged. */
  function colourName(o) { return typeof H.giftColourName === 'function' ? H.giftColourName(o) : String((o && o.title) || ''); }
  /* A quiet row under the receipt ("Gift bag: Black · Change to Beige"). Rendered against the
     alternative — a pill on the gift-bag slide — on 21 Oct: the slide sits eight swipes deep,
     the row is in view on every open. */
  function giftRowHtml(h) {
    var g = h.gift;
    if (!g) return '';
    return 'Gift bag: <b>' + esc(colourName(g.current)) + '</b>' + g.others.map(function (o) {
      return ' <span aria-hidden="true">·</span> <button type="button" class="hgn-kr__gift-swap" data-kr-gift="' + esc(o.variantId) + '" data-kr-gift-key="' + esc(g.line.key) + '">Change to ' + esc(colourName(o)) + '</button>';
    }).join('');
  }

  /* ── Kit-price row (the existing pair offer, at kit price, in the card) ── */
  function offerLineFor(cart, tier) {
    var at = A();
    var hit = null;
    ((cart && cart.items) || []).forEach(function (it) {
      if (hit || !it.properties || it.properties._hgn_offer_kind !== 'pair') return;
      var t = typeof at.classifyTier === 'function' ? at.classifyTier(it.product_type) : null;
      if (!t || t === tier) hit = it;
    });
    return hit;
  }
  function upsellModel(inst, h, st) {
    var cart = h.cart, at = A();
    var line = offerLineFor(cart, h.tier);
    if (line) {
      var pp = parseInt(line.properties._hgn_offer_pair_pres, 10);
      return { state: 'added', name: cardName(line.product_title || line.title), price: isFinite(pp) && pp > 0 ? money(pp, h.cur) : '' };
    }
    if (st.upsell && st.upsell.sig === upsellSig(inst, h)) return st.upsell.model;
    return { state: 'none' };
  }
  function upsellSig(inst, h) {
    var s = '';
    try { s = inst._offerSignature(); } catch (e) {}
    return s + '|' + h.tier + '|' + (h.cart.currency || '');
  }
  /* Resolves the candidates once per basket signature, while the drawer is open (the ladder
     hits two workers and /products/<handle>.js; a closed drawer never pays for it). */
  function resolveUpsell(inst, h, st) {
    var at = A();
    var sig = upsellSig(inst, h);
    if (st.upsell && st.upsell.sig === sig) return;
    st.upsell = { sig: sig, model: { state: 'none' }, done: false };
    var entry = st.upsell;
    var info = null;
    try { info = typeof inst._pairEligible === 'function' ? inst._pairEligible() : null; } catch (e) { info = null; }
    if (!info || typeof at.collectDesigns !== 'function' || typeof at.pairPricePres !== 'function') { entry.done = true; return; }
    var pairPres = at.pairPricePres(inst, h.tier);
    if (pairPres == null) { entry.done = true; return; }
    var seeds = h.designs.map(function (it) { return it.handle; }).filter(Boolean);
    /* (the drawer's settle does not wait for this row: it fills in below the fold, after the reveal) */
    at.collectDesigns(h.tier, info.handles || {}, seeds, 4).then(function (list) {
      var cands = [];
      (list || []).forEach(function (d) {
        if (cands.length >= 4) return;
        var c = null;
        try { c = inst._pairFromDesign(h.tier, d); } catch (e) { c = null; }
        if (c) cands.push(c);
      });
      if (st.upsell !== entry) return;
      entry.done = true;
      entry.model = cands.length ? { state: 'offer', cands: cands, pairPres: pairPres } : { state: 'none' };
    }).catch(function () { entry.done = true; }).then(function () {
      if (st.upsell !== entry) return;
      schedule(inst);
    });
  }
  function upsellHtml(inst, h, model) {
    var cur = h.cur;
    if (model.state === 'added') {
      return '<p class="hgn-kr__up-done">' + CHECK + '<span>Added <b>' + esc(model.name) + '</b>' + (model.price ? ' at ' + esc(model.price) : '') + '</span></p>';
    }
    if (model.state !== 'offer') return '';
    var c0 = model.cands[0];
    var same = model.cands.every(function (c) { return c.retailPres === c0.retailPres; });
    var sub = money(model.pairPres, cur) + ' each' + (same ? ' (usually ' + money(c0.retailPres, cur) + ')' : '');
    try {
      var ctx = inst._attachContext();
      var after = (inst._lastDisplayedSubtotalCents || 0) + model.pairPres;
      if (ctx && ctx.giftName && ctx.giftCents && !ctx.giftUnlocked && after >= ctx.giftCents) sub += ' · one more unlocks your free ' + esc(ctx.giftName);
    } catch (e) {}
    var cards = model.cands.map(function (c, i) {
      var d = c.item;
      return '<div class="hgn-kr__up-card">' +
        '<button type="button" class="hgn-kr__up-img" data-kr-qv="up:' + i + '" aria-label="Quick view: ' + esc(cardName(d.title)) + '">' + (d.image ? '<img src="' + esc(thumb(d.image, 240)) + '" alt="" loading="lazy">' : '') + '</button>' +
        qvBtn('up:' + i, cardName(d.title)) +
        '<button type="button" class="hgn-kr__up-plus" data-kr-up="' + i + '" aria-label="Add ' + esc(cardName(d.title)) + ' for ' + esc(money(c.pairPres, cur)) + '">' + PLUS + '</button>' +
        '<span class="hgn-kr__up-n">' + esc(cardName(d.title)) + '</span>' +
        /* the kit price only: "usually £x" is in the row's subline — no strike-through anywhere (21 Oct) */
        '<span class="hgn-kr__up-p"><b>' + money(c.pairPres, cur) + '</b></span>' +
      '</div>';
    }).join('');
    return '<p class="hgn-kr__up-h">Add another design at kit price</p>' +
      '<p class="hgn-kr__up-s">' + sub + '</p>' +
      '<div class="hgn-kr__up-rail">' + cards + '</div>';
  }

  /* ── Swap ──────────────────────────────────────────────────────────── */
  function swapSeeds(h, key) { return h.designs.filter(function (it) { return it.key !== key; }).map(function (it) { return it.handle; }).filter(Boolean); }
  function inBagHandles(cart) {
    var m = {};
    ((cart && cart.items) || []).forEach(function (it) { if (it.handle) m[String(it.handle).toLowerCase()] = true; });
    return m;
  }
  /* Same tier, in stock, not in the bag. Ranked: what goes with the kit's other designs
     (complete-the-look, seeded with them), then the shopper's own ladder (recently viewed,
     wishlist), then the tier's best sellers (the Bestsellers Edit picks). Shown from the
     sources' own data (no /products burst); stock is re-checked on the tap. */
  function swapSuggestions(h, key, taken) {
    var at = A(), handles = inBagHandles(h.cart), tier = h.tier;
    if (taken) handles[String(taken).toLowerCase()] = true;
    var out = [], seen = {};
    function take(list) {
      (list || []).forEach(function (d) {
        if (out.length >= 6 || !d || !d.handle || !d.variantId) return;
        var k = String(d.handle).toLowerCase();
        if (seen[k] || handles[k] || d.available === false) return;
        seen[k] = true;
        out.push(d);
      });
    }
    var ctl = typeof at.fromCtl === 'function' ? at.fromCtl(tier, handles, swapSeeds(h, key)) : Promise.resolve([]);
    return Promise.resolve(ctl).catch(function () { return []; }).then(function (c) {
      take(c);
      if (out.length >= 6) return out;
      try { if (typeof at.fromViewed === 'function') take(at.fromViewed(tier, handles)); } catch (e) {}
      if (out.length >= 6) return out;
      var wl = typeof at.fromWishlist === 'function' ? at.fromWishlist(tier, handles) : Promise.resolve([]);
      return Promise.resolve(wl).catch(function () { return []; }).then(function (w) {
        take(w);
        if (out.length >= 6) return out;
        /* TODO HGN Assist: when Assist returns to the theme, the strip's last tile becomes
           "Not sure? Ask HGN" (KIT-READY-SPEC §4, Matt's TODO) — hand Assist the kit's other
           designs and this tier, and swap in its pick through doSwap() like any tile. */
        var ck = window.HGN && window.HGN.curatedKits;
        var def = ck && typeof ck.bySlug === 'function' ? ck.bySlug(BEST_SLUG[tier]) : null;
        var best = def ? [].concat(def.picks || [], def.backupPicks || []) : [];
        best = best.filter(function (hd) { var k = String(hd).toLowerCase(); return !seen[k] && !handles[k]; });
        var need = 6 - out.length;
        var queue = best.slice(0, need + 2);
        /* sequential, capped: never a burst of /products/* (the bot check) */
        return queue.reduce(function (p, hd) {
          return p.then(function () {
            if (out.length >= 6 || typeof at.liveProduct !== 'function') return;
            return at.liveProduct(hd).then(function (prod) {
              if (!prod || prod.available === false || !Array.isArray(prod.variants)) return;
              var v = prod.variants.filter(function (x) { return x && x.available !== false; })[0];
              if (!v) return;
              take([{ handle: prod.handle || hd, title: prod.title, image: prod.featured_image || '', variantId: v.id, retailPres: v.price, source: 'best' }]);
            });
          });
        }, Promise.resolve()).then(function () { return out; });
      });
    });
  }
  function swapStripHtml(h, st) {
    var s = st.swap;
    if (!s) return '';
    var others = h.designs.length - 1;
    var body;
    if (s.loading) body = '<div class="hgn-kr__sw-rail hgn-kr__sw-rail--loading" aria-hidden="true"><span></span><span></span><span></span><span></span></div>';
    else if (!s.list || !s.list.length) body = '<p class="hgn-kr__sw-empty">No other designs to swap in right now.</p>';
    else {
      body = '<div class="hgn-kr__sw-rail">' + s.list.map(function (d, i) {
        return '<div class="hgn-kr__sw-t"><button type="button" class="hgn-kr__sw-c' + (s.busy === i ? ' is-busy' : '') + (s.gone && s.gone[i] ? ' is-gone' : '') + '" data-kr-pick="' + i + '"' + (s.busy != null || (s.gone && s.gone[i]) ? ' disabled' : '') + ' aria-label="Swap for ' + esc(cardName(d.title)) + '">' +
          '<span class="hgn-kr__sw-img">' + (d.image ? '<img src="' + esc(thumb(d.image, 200)) + '" alt="" loading="lazy">' : '') + '</span>' +
          '<span class="hgn-kr__sw-n">' + (s.gone && s.gone[i] ? 'Sold out' : esc(cardName(d.title))) + '</span>' +
        '</button>' + qvBtn('swap:' + i, cardName(d.title), ' hgn-kr__qvi--sm').replace('<button ', '<button' + (s.busy != null ? ' disabled' : '') + ' ') + '</div>';
      }).join('') + '</div>';
    }
    var idx = 0;
    h.designs.forEach(function (it, i) { if (it.key === s.key) idx = i + 1; });
    return '<div class="hgn-kr__sw" style="--kr-sw-arrow:' + Math.min(86, 10 + (idx % 4) * 22) + '%">' +
      '<p class="hgn-kr__sw-h">Swap <b>' + esc(s.name) + '</b> for…</p>' +
      '<button type="button" class="hgn-kr__sw-x" data-kr-keep>Keep it</button>' +
      body +
      (s.err ? '<p class="hgn-kr__sw-err" role="alert">' + esc(s.err) + '</p>' : '') +
      '<p class="hgn-kr__sw-why">Picked from what goes with your other ' + others + ' design' + (others === 1 ? '' : 's') + ' · same kit price</p>' +
    '</div>';
  }
  function editDesignHandles(edit) {
    try {
      var ck = window.HGN && window.HGN.curatedKits;
      var def = edit && edit.slug && ck && typeof ck.bySlug === 'function' ? ck.bySlug(edit.slug) : null;
      if (!def) return null;
      var set = {};
      [].concat(def.picks || [], def.backupPicks || []).forEach(function (hd) { set[String(hd).toLowerCase()] = true; });
      return set;
    } catch (e) { return null; }
  }
  function postJson(url, body) {
    return fetch(url, {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().catch(function () { return null; }).then(function (j) { return { ok: r.ok, status: r.status, j: j }; });
    }).catch(function () { return { ok: false, status: 0, j: null }; });
  }
  /* Add the new design with the old line's properties, THEN take the old line out (add first, as
     _swapBundleGift does, so a failed add leaves the kit whole). A failed remove is retried, then
     the new line is rolled back; should that fail too, the cart is re-read and the extra design
     taken out once more, and the message says what the bag really holds. inst._kitReadyBusy holds
     from the tap until the refreshed cart has painted: the core's _proceedToCheckout waits on it,
     so nothing is minted from a mid-swap cart; every other Swap is disabled meanwhile. */
  var MSG_UNCHANGED = 'That didn’t go through — your kit is unchanged. Try again?';
  var MSG_EXTRA = 'That swap didn’t finish — both designs are in your kit now. Try the swap again, or use Remove kit below to start over.';
  function swapSettled(inst, st) { inst._kitReadyBusy = false; st.swapBusy = null; paintRailState(st); }
  function doSwap(inst, h, st, i, via) {
    var s = st.swap;
    if (!s || !s.list || s.busy != null || st.swapBusy) return;
    var d = s.list[i];
    var old = null;
    (h.cart.items || []).forEach(function (it) { if (it.key === s.key) old = it; });
    if (!d || !old || !swappable(old)) return;
    s.busy = i; s.err = '';
    st.swapBusy = { handle: d.handle, key: old.key };
    inst._kitReadyBusy = true;
    paintSwap(inst, h, st);
    paintRailState(st);
    var keepQty = Math.max(0, (old.quantity || 1) - 1);
    var slideAt = 0;
    h.designs.forEach(function (it, k) { if (it.key === old.key) slideAt = k + 1; });
    var newKey = null, newVid = null;
    var at = A();
    var live = typeof at.liveProduct === 'function' ? at.liveProduct(d.handle) : Promise.resolve(null);
    live.then(function (prod) {
      var v = null;
      if (prod && prod.available !== false && Array.isArray(prod.variants)) {
        prod.variants.forEach(function (x) { if (!v && String(x.id) === String(d.variantId) && x.available !== false) v = x; });
        if (!v) v = prod.variants.filter(function (x) { return x && x.available !== false; })[0] || null;
      }
      if (!v) { s.busy = null; s.gone = s.gone || {}; s.gone[i] = true; swapSettled(inst, st); paintSwap(inst, h, st); return null; }
      var props = {};
      var src = old.properties || {};
      for (var k in src) if (Object.prototype.hasOwnProperty.call(src, k)) props[k] = src[k];
      /* The edit's name drops once none of its designs remain (kitProgress's kitEditLabel rule). */
      var stripEdit = false;
      var set = h.edit ? editDesignHandles(h.edit) : null;
      if (set) {
        var left = h.designs.filter(function (it) { return it.key !== old.key && set[String(it.handle || '').toLowerCase()]; }).length;
        if (!left && !set[String(prod.handle || d.handle).toLowerCase()]) stripEdit = true;
      }
      if (stripEdit) { delete props._hgn_edit_title; delete props._hgn_edit_slug; delete props._hgn_edit_skin; }
      /* The curated / kit-nudge / drawer-kit fetch stampers tag any `_bundle_type` add that has
         no `_hgn_src` and consume their armed source (with an "accepted" beacon). A swap is not
         a new kit: a line that carried no source gets the swap's own, so none of them fire. */
      if (!props._hgn_src) props._hgn_src = 'kitready_swap:' + h.tier;
      newVid = v.id;
      return postJson('/cart/add.js', { items: [{ id: parseInt(v.id, 10), quantity: 1, properties: props }] }).then(function (add) {
        if (!add.ok) throw { step: 'add', status: add.status, clean: true };
        var added = add.j && add.j.items && add.j.items[0];
        newKey = added && added.key;
        var remove = function () { return postJson('/cart/change.js', { id: old.key, quantity: keepQty }); };
        return remove().then(function (r) { return r.ok ? r : remove(); }).then(function (r) {
          if (r.ok) return { vid: v.id, stripEdit: stripEdit, cart: r.j };
          if (!newKey) throw { step: 'remove', status: r.status, clean: false };
          return postJson('/cart/change.js', { id: newKey, quantity: 0 }).then(function (rb) { throw { step: 'remove', status: r.status, clean: rb.ok }; });
        });
      });
    }).then(function (res) {
      if (!res) return null;
      try { var kp = window.HGN && window.HGN.kitProgress; if (!keepQty && kp && typeof kp.pruneManifestForLineKey === 'function') kp.pruneManifestForLineKey(old.key); } catch (e) {}
      replaceInOrder(h.bundle.id, old.variant_id, res.vid, keepQty > 0);
      var chain = Promise.resolve();
      if (res.stripEdit && res.cart && res.cart.items) {
        /* the other lines of the kit lose the edit too (one write each, in turn) */
        res.cart.items.forEach(function (it) {
          var p = it.properties || {};
          if (String(p._bundle_id || '') !== String(h.bundle.id) || !p._hgn_edit_title) return;
          chain = chain.then(function () {
            var q = {};
            for (var k in p) if (Object.prototype.hasOwnProperty.call(p, k) && k.indexOf('_hgn_edit_') !== 0) q[k] = p[k];
            return postJson('/cart/change.js', { id: it.key, quantity: it.quantity || 1, properties: q });
          });
        });
      }
      return chain.then(function () {
        st.swap = null;
        st.flash = 'Swapped';
        /* keyboard focus comes back to this slide's ↻ Swap once the rail is rebuilt */
        if (st.host && st.host.contains(document.activeElement)) st.refocus = { s: slideAt, pill: true };
        offer('swap_done', { tier: h.tier, reason: via || h.how, how: h.how, surface: h.edit ? h.edit.slug : '' });
        /* the new design morphs in over the old one (View Transition), else the CSS cross-fade */
        var media = st.host && st.host.querySelector('.hgn-kr__slide[data-kr-key="' + String(old.key).replace(/"/g, '') + '"] .hgn-kr__media');
        var vt = media && typeof document.startViewTransition === 'function' && !reducedMotion();
        st.swapFx = { vid: String(res.vid), at: Date.now(), vt: !!vt };
        if (!vt) return inst.refresh();
        var off = vtOn(media, 'kr-swap');
        try {
          var t = document.startViewTransition(function () {
            media.style.viewTransitionName = '';
            return inst.refresh().then(function () { return new Promise(function (r) { setTimeout(r, 0); }); });
          });
          t.finished.then(function () { off(); clearSwapName(st); }, function () { off(); clearSwapName(st); });
          return t.updateCallbackDone;
        } catch (e) { off(); return inst.refresh(); }
      });
    }).then(function () { swapSettled(inst, st); }, function (e) {
      warn(e);
      var fail = function (msg) {
        swapSettled(inst, st);
        if (!st.swap) return;
        st.swap.busy = null;
        st.swap.err = msg;
        paintSwap(inst, h, st);
      };
      if (!e || e.clean !== false) return inst.refresh().then(function () { fail(MSG_UNCHANGED); }, function () { fail(MSG_UNCHANGED); });
      /* the rollback failed too: re-read the bag; an extra design in this kit gets one more try out */
      return inst.refresh().then(function () {
        var extra = null;
        ((inst.cart && inst.cart.items) || []).forEach(function (it) {
          var p = it.properties || {};
          if (extra || String(p._bundle_id || '') !== String(h.bundle.id)) return;
          if (newKey ? it.key === newKey : (String(it.variant_id) === String(newVid) && it.key !== old.key)) extra = it;
        });
        if (!extra) return MSG_UNCHANGED;
        return postJson('/cart/change.js', { id: extra.key, quantity: 0 }).then(function (r) {
          return inst.refresh().then(function () { return r.ok ? MSG_UNCHANGED : MSG_EXTRA; });
        });
      }).then(fail, function () { fail(MSG_EXTRA); });
    });
  }
  function clearSwapName(st) {
    var m = st.host && st.host.querySelector('[style*="kr-swap"]');
    if (m) m.style.viewTransitionName = '';
  }
  /* Swap only a single-unit kit line (session 29, 21 Oct). The core prices a qty-2 kit line as one
     kit unit + one at retail; swapping one unit out leaves both designs inside the bundle at the kit
     price, i.e. a design for free. A doubled design keeps its line controls in the bag instead. */
  function swappable(it) { return !!it && (parseInt(it.quantity, 10) || 1) === 1; }
  function firstSwappable(h) { for (var i = 0; i < h.designs.length; i++) if (swappable(h.designs[i])) return { it: h.designs[i], at: i + 1 }; return null; }
  function openSwap(inst, h, st, key) {
    if (st.swapBusy) return;
    var it = null;
    h.designs.forEach(function (x) { if (x.key === key) it = x; });
    if (!it || !swappable(it)) return;
    if (st.swap && st.swap.key === key) { st.swap = null; paintSwap(inst, h, st); paintRailState(st); return; }
    st.swap = { key: key, name: cardName(it.product_title || it.title), loading: true, list: null };
    offer('swap_open', { tier: h.tier, reason: h.how, surface: h.edit ? h.edit.slug : '' });
    paintSwap(inst, h, st);
    paintRailState(st);
    var mine = st.swap;
    swapSuggestions(h, key, st.swapBusy && st.swapBusy.handle).then(function (list) {
      if (st.swap !== mine) return;
      mine.loading = false;
      mine.list = list;
      paintSwap(inst, h, st);
    }).catch(function () {
      if (st.swap !== mine) return;
      mine.loading = false;
      mine.list = [];
      paintSwap(inst, h, st);
    });
  }

  /* ── Card state + paint ────────────────────────────────────────────── */
  function stateOf(inst) {
    if (!inst._kr) inst._kr = { host: null, blocks: {}, built: false, skin: '', bid: '', swap: null, swapFx: null, flash: '', upsell: null, slide: 0 };
    return inst._kr;
  }
  function el(tag, cls, attrs) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (attrs) for (var k in attrs) if (Object.prototype.hasOwnProperty.call(attrs, k)) e.setAttribute(k, attrs[k]);
    return e;
  }
  function setBlock(st, name, html) {
    var b = st.blocks[name];
    if (!b) return false;
    if (b.__krHtml === html) return false;
    b.__krHtml = html;
    b.innerHTML = html;
    b.hidden = !html;
    return true;
  }
  function buildFull(st, h) {
    var host = st.host;
    host.className = 'hgn-kr hgn-kr--skin-' + h.skin;
    host.innerHTML = '';
    var top = el('div', 'hgn-kr__top');
    top.innerHTML =
      '<span class="hgn-kr__chip">' + CHECK + '<span>In your ' + esc(bagWord()) + '</span></span>' +
      '<h3 class="hgn-kr__name" data-kr-name></h3>' +
      '<p class="hgn-kr__sub" data-kr-sub></p>';
    var railWrap = el('div', 'hgn-kr__railwrap is-start');
    var rail = el('div', 'hgn-kr__rail', { 'data-kr-rail': '', role: 'region', 'aria-roledescription': 'carousel', 'aria-label': 'What’s in your kit', tabindex: '0' });
    var track = el('div', 'hgn-kr__track');
    rail.appendChild(track);
    railWrap.appendChild(rail);
    railWrap.insertAdjacentHTML('beforeend',
      '<button type="button" class="hgn-kr__arrow hgn-kr__arrow--prev" data-kr-step="-1" aria-label="Previous"><svg viewBox="0 0 12 12" fill="none" aria-hidden="true"><path d="M7.5 2.5 4 6l3.5 3.5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg></button>' +
      '<button type="button" class="hgn-kr__arrow hgn-kr__arrow--next" data-kr-step="1" aria-label="Next"><svg viewBox="0 0 12 12" fill="none" aria-hidden="true"><path d="M4.5 2.5 8 6l-3.5 3.5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg></button>');
    var thumbs = el('div', 'hgn-kr__thumbs', { role: 'group', 'aria-label': 'Jump to' });
    var swap = el('div', 'hgn-kr__swap-host', { 'data-kr-swap-host': '' });
    var flash = el('p', 'hgn-kr__flash', { 'data-kr-flash': '', role: 'status', 'aria-live': 'polite' });
    var rcpt = el('div', 'hgn-kr__rcpt', { 'data-kr-rcpt': '' });
    var links = el('p', 'hgn-kr__links');
    links.innerHTML = '<button type="button" class="hgn-kr__link" data-kr-edit>Edit kit</button><button type="button" class="hgn-kr__link" data-kr-keep-shopping>Keep shopping</button>';
    var gift = el('p', 'hgn-kr__gift');
    var up = el('div', 'hgn-kr__up', { 'data-kr-up-host': '', role: 'group', 'aria-label': 'Add another design at kit price' });
    /* the one live region for the row: a short "Added …" — never the whole re-rendered row */
    var say = el('p', 'hgn-kr__sr', { role: 'status', 'aria-live': 'polite' });
    var rm = el('p', 'hgn-kr__rmwrap');
    rm.innerHTML = '<button type="button" class="hgn-kr__rm" data-kr-remove>Remove kit</button>';
    [top, railWrap, thumbs, swap, flash, rcpt, gift, links, up, rm, say].forEach(function (n) { host.appendChild(n); });
    st.blocks = { top: top, wrap: railWrap, rail: rail, track: track, thumbs: thumbs, swap: swap, flash: flash, rcpt: rcpt, gift: gift, up: up, say: say };
    swap.hidden = true; flash.hidden = true; gift.hidden = true; up.hidden = true;
  }
  function ensureHost(inst, st) {
    if (st.host && st.host.isConnected) return st.host;
    var host = el('section', 'hgn-kr', { 'data-hgn-kit-ready': '', 'aria-label': 'Your kit is in your bag' });
    var body = inst.body;
    var before = body && (body.querySelector('[data-hgn-side-cart-kit-list]') || body.firstChild);
    if (body) body.insertBefore(host, before ? before : null);
    st.host = host;
    st.built = false;
    wireCard(inst, st);
    return host;
  }
  function paintSwap(inst, h, st) {
    if (!st.blocks.swap) return;
    setBlock(st, 'swap', swapStripHtml(h, st));
  }
  function paintRailState(st) {
    var rail = st.blocks.rail;
    if (!rail) return;
    var pills = rail.querySelectorAll('[data-kr-swap]');
    for (var i = 0; i < pills.length; i++) {
      var on = !!(st.swap && st.swap.key === pills[i].getAttribute('data-kr-swap'));
      pills[i].classList.toggle('is-on', on);
      pills[i].setAttribute('aria-expanded', on ? 'true' : 'false');
    }
    var all = rail.querySelectorAll('[data-kr-swap], [data-kr-swap-first]');
    for (var j = 0; j < all.length; j++) all[j].disabled = !!st.swapBusy;
  }
  function slideWidth(rail) {
    var s = rail && rail.querySelector('.hgn-kr__slide');
    if (!s) return 0;
    var gap = 8;
    try { gap = parseFloat(window.getComputedStyle(s.parentNode).columnGap) || 8; } catch (e) {}
    /* offsetWidth is the layout width (the depth scale doesn't touch it); a collapsed slide
       (a browser that dropped both width declarations) falls back to the rail's own maths */
    var w = s.offsetWidth || Math.min(300, Math.round(((rail.clientWidth || 0) - 22) / 1.25));
    return w > 0 ? w + gap : 0;
  }
  /* one step from where the rail is heading (two quick presses = two slides, not one) */
  function stepFrom(st, d) {
    var at = st.goTo != null && Date.now() - (st.goAt || 0) < 700 ? st.goTo : (st.slide || 0);
    var max = st.blocks.rail ? st.blocks.rail.querySelectorAll('.hgn-kr__slide').length - 1 : 0;
    return Math.max(0, Math.min(max, at + d));
  }
  function goSlide(st, n, smooth) {
    var rail = st.blocks.rail;
    if (!rail) return;
    st.goTo = n; st.goAt = Date.now();
    var w = slideWidth(rail);
    if (!w) return;
    var left = Math.max(0, n * w);
    try { rail.scrollTo({ left: left, behavior: smooth && !reducedMotion() ? 'smooth' : 'auto' }); } catch (e) { rail.scrollLeft = left; }
  }
  /* Active slide from the scroll position: its caption shows, its thumb rings, the next slide
     starts loading, far slides skip rendering (content-visibility), the arrows know the ends, and
     only the slide in view keeps its buttons in the tab order. */
  function syncNav(st) {
    var rail = st.blocks.rail;
    if (!rail) return 0;
    var slides = rail.querySelectorAll('.hgn-kr__slide');
    var w = slideWidth(rail);
    var n = w ? Math.round(rail.scrollLeft / w) : 0;
    var max = rail.scrollWidth - rail.clientWidth;
    if (max > 0 && rail.scrollLeft >= max - 2) n = slides.length - 1;
    for (var i = 0; i < slides.length; i++) {
      slides[i].classList.toggle('is-active', i === n);
      slides[i].classList.toggle('is-far', Math.abs(i - n) > 2);
      if (i === n + 1) { var im = slides[i].querySelector('img[loading="lazy"]'); if (im) im.loading = 'eager'; }
      var bs = slides[i].querySelectorAll('button');
      for (var q = 0; q < bs.length; q++) { if (i === n) bs[q].removeAttribute('tabindex'); else bs[q].setAttribute('tabindex', '-1'); }
    }
    var th = st.blocks.thumbs ? st.blocks.thumbs.querySelectorAll('[data-kr-thumb]') : [];
    for (var k = 0; k < th.length; k++) { th[k].classList.toggle('is-on', k === n); if (k === n) th[k].setAttribute('aria-current', 'true'); else th[k].removeAttribute('aria-current'); }
    if (st.blocks.wrap) { st.blocks.wrap.classList.toggle('is-start', n === 0); st.blocks.wrap.classList.toggle('is-end', n >= slides.length - 1); }
    return n;
  }
  /* Thumb jump: a View Transition crossfade of the rail alone (the page's root transition is
     switched off for it); smooth scroll where View Transitions don't exist; instant under
     reduced motion. */
  function vtOn(el, name) {
    if (el) el.style.viewTransitionName = name;
    document.documentElement.classList.add('hgn-kr-vt');
    return function () {
      if (el) el.style.viewTransitionName = '';
      document.documentElement.classList.remove('hgn-kr-vt');
    };
  }
  function jumpTo(st, n) {
    st.navAt = Date.now();
    if (reducedMotion()) { goSlide(st, n, false); syncNav(st); return; }
    if (typeof document.startViewTransition !== 'function') { goSlide(st, n, true); return; }
    var off = vtOn(st.blocks.rail, 'kr-rail');
    try {
      var vt = document.startViewTransition(function () { goSlide(st, n, false); syncNav(st); });
      vt.finished.then(off, off);
    } catch (e) { off(); goSlide(st, n, true); }
  }
  /* Haptics (Android): a 10 ms tick when the kit lands and on each thumb snap — feature-detected,
     only after a gesture on this page, never under reduced motion. */
  var gestured = false;
  ['pointerdown', 'keydown'].forEach(function (t) { document.addEventListener(t, function () { gestured = true; }, true); });
  function haptic() {
    try {
      if (reducedMotion() || typeof navigator.vibrate !== 'function') return;
      var ua = navigator.userActivation;
      if (ua ? !ua.hasBeenActive : !gestured) return;
      navigator.vibrate(10);
    } catch (e) {}
  }

  /* ── The Reveal (21 Oct): a bundle's first show only, once the drawer has settled. 0–560 ms
     arrival (card in, tick, gift bag lands, polaroids drop, one sheen); to 1500 ms the receipt's rows
     stagger in (figures final from frame 1) and the kit lands; to 2450 ms the rail peeks a quarter
     slide and back, thumbs light, one sheen on the express tiles. CSS does the motion (transform +
     opacity); this file sequences and cancels. Any touch → the final state (reveal_skipped
     {reason: phase}); reduced motion → none of it; later opens → the final state. */
  var REVEAL_KEY = 'hgn_kitready_reveal';
  var counts = { reveals: 0, nudges: 0, skips: 0 };
  function revealSeen(bid) { var m = lsGet(REVEAL_KEY); return !!(m && m[bid]); }
  function revealMark(bid) {
    var m = lsGet(REVEAL_KEY) || {};
    m[bid] = Date.now();
    var ks = Object.keys(m);
    if (ks.length > 12) { ks.sort(function (a, b) { return m[a] - m[b]; }); delete m[ks[0]]; }
    lsSet(REVEAL_KEY, m);
  }
  function maybeReveal(inst, st, h) {
    if (st.revealBid === h.bundle.id) return;
    st.revealBid = h.bundle.id;
    if (revealSeen(h.bundle.id) || reducedMotion()) return;
    st.motion = 'pending';
    st.host.classList.add('is-pre');
    var t0 = Date.now();
    (function poll() {
      if (st.motion !== 'pending') return;
      if (!inst.isOpen || !st.host || !st.host.isConnected) { endPre(st); return; }
      if (inst.panel && inst.panel.hasAttribute('data-hgn-sc-settling') && Date.now() - t0 < 9000) { setTimeout(poll, 30); return; }
      /* decode before anything moves, so nothing pops in half-loaded (capped) */
      var imgs = Array.prototype.slice.call(st.host.querySelectorAll('.hgn-kr__slide--collage img, .hgn-kr__slide[data-kr-slide="1"] img, .hgn-kr__thumb img'));
      var dec = Promise.all(imgs.map(function (im) { try { if (im.loading === 'lazy') im.loading = 'eager'; return im.decode ? im.decode().catch(function () {}) : null; } catch (e) { return null; } }));
      Promise.race([dec, new Promise(function (r) { setTimeout(r, 700); })]).then(function () {
        if (st.motion === 'pending' && inst.isOpen && st.host) startReveal(inst, st, h);
      });
    })();
  }
  function endPre(st) {
    st.motion = '';
    st.revealBid = '';
    if (st.host) st.host.classList.remove('is-pre');
  }
  var CANCEL_ON = ['pointerdown', 'wheel', 'keydown'];
  function startReveal(inst, st, h) {
    revealMark(h.bundle.id);
    counts.reveals++;
    var host = st.host;
    st.revealTimers = [];
    st.motion = 'arrival';
    host.classList.remove('is-pre');
    host.classList.add('is-reveal');
    var at = function (ms, fn) { st.revealTimers.push(setTimeout(fn, ms)); };
    at(380, haptic);
    at(560, function () { st.motion = 'value'; });
    at(1500, function () {
      st.motion = 'invite';
      var rail = st.blocks.rail;
      if (rail && rail.scrollLeft < 4 && st.blocks.track) {
        /* a quarter of the next slide, in px (no container units: old Safari drops them) */
        st.blocks.track.style.setProperty('--kr-nudge', -Math.round(Math.max(0, slideWidth(rail) - 8) * 0.25) + 'px');
        st.blocks.track.classList.add('is-nudge');
        counts.nudges++;
      }
      if (inst.footEl) inst.footEl.classList.add('hgn-side-cart__foot--kr-sheen');
    });
    at(2450, function () { finishReveal(inst, st, false); });
    st.revealCancel = function () { finishReveal(inst, st, true); };
    CANCEL_ON.forEach(function (t) { document.addEventListener(t, st.revealCancel, { capture: true, passive: true }); });
  }
  function finishReveal(inst, st, skipped) {
    if (!st.revealTimers) return;
    var phase = st.motion;
    st.revealTimers.forEach(clearTimeout);
    st.revealTimers = null;
    CANCEL_ON.forEach(function (t) { document.removeEventListener(t, st.revealCancel, { capture: true, passive: true }); });
    if (st.host) st.host.classList.remove('is-reveal', 'is-pre');
    if (st.blocks.track) st.blocks.track.classList.remove('is-nudge');
    if (inst.footEl) inst.footEl.classList.remove('hgn-side-cart__foot--kr-sheen');
    st.motion = 'idle';
    if (skipped) { counts.skips++; offer('reveal_skipped', { tier: st.tier, reason: phase }); }
  }

  /* Delegated taps on the card (bound once per host). */
  function wireCard(inst, st) {
    var host = st.host;
    var raf = 0;
    host.addEventListener('scroll', function (e) {
      if (!e.target || !e.target.hasAttribute || !e.target.hasAttribute('data-kr-rail')) return;
      if (raf) return;
      raf = requestAnimationFrame(function () {
        raf = 0;
        var n = syncNav(st);
        if (n !== st.slide) {
          st.slide = n;
          if (n > 0 && st.userScroll && Date.now() - (st.navAt || 0) > 900) offerOnce('swipe:' + st.bid + ':' + n, 'swipe', { tier: st.tier, n: n + 1, reason: 'n' + (n + 1) });
        }
      });
    }, true);
    ['touchstart', 'pointerdown', 'wheel'].forEach(function (t) {
      host.addEventListener(t, function (e) { if (e.target && e.target.closest && e.target.closest('[data-kr-rail]')) st.userScroll = true; }, { passive: true, capture: true });
    });
    host.addEventListener('keydown', function (e) {
      if (!e.target || !e.target.hasAttribute || !e.target.hasAttribute('data-kr-rail')) return;
      if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
      e.preventDefault();
      st.userScroll = true;
      goSlide(st, stepFrom(st, e.key === 'ArrowRight' ? 1 : -1), true);
    });
    host.addEventListener('click', function (e) {
      var t = e.target && e.target.closest ? e.target : null;
      if (!t) return;
      var h = st.hero;
      if (!h) return;
      var b;
      if ((b = t.closest('[data-kr-thumb]'))) {
        var tn = parseInt(b.getAttribute('data-kr-thumb'), 10) || 0;
        haptic();
        jumpTo(st, tn);
        offerOnce('thumb:' + st.bid + ':' + tn, 'swipe', { tier: h.tier, n: tn + 1, reason: 'thumb' });
        return;
      }
      if ((b = t.closest('[data-kr-qv]'))) { e.preventDefault(); openQv(inst, h, st, b.getAttribute('data-kr-qv'), b); return; }
      if ((b = t.closest('[data-kr-step]'))) { st.userScroll = true; goSlide(st, stepFrom(st, parseInt(b.getAttribute('data-kr-step'), 10) || 0), true); return; }
      if (t.closest('[data-kr-swap-first]')) {
        var fs = firstSwappable(h);
        if (st.swapBusy || !fs) return;
        st.userScroll = true;
        goSlide(st, fs.at, true);
        if (!st.swap || st.swap.key !== fs.it.key) openSwap(inst, h, st, fs.it.key);
        return;
      }
      if (t.closest('[data-kr-next]')) { st.userScroll = true; goSlide(st, 1, true); return; }
      if ((b = t.closest('[data-kr-swap]'))) { e.preventDefault(); openSwap(inst, h, st, b.getAttribute('data-kr-swap')); return; }
      if (t.closest('[data-kr-keep]')) { st.swap = null; paintSwap(inst, h, st); paintRailState(st); return; }
      if ((b = t.closest('[data-kr-pick]'))) { doSwap(inst, h, st, parseInt(b.getAttribute('data-kr-pick'), 10) || 0); return; }
      if ((b = t.closest('[data-kr-up]'))) { addUpsell(inst, h, st, parseInt(b.getAttribute('data-kr-up'), 10) || 0, b); return; }
      if (t.closest('[data-kr-edit]')) {
        /* No route moves a kit that is already in the bag back into the builder (and in arm B a
           complete kit would land straight back in the bag). Editing happens here: the swap
           strip opens on the design in view, or the first design. */
        offer('edit_kit', { tier: h.tier, reason: h.how, surface: h.edit ? h.edit.slug : '' });
        var n = Math.max(1, Math.min(h.designs.length, st.slide || 1));
        var d = h.designs[n - 1];
        if (!d) return;
        goSlide(st, n, true);
        if (!st.swap || st.swap.key !== d.key) openSwap(inst, h, st, d.key);
        return;
      }
      if (t.closest('[data-kr-keep-shopping]')) { offer('keep_shopping', { tier: h.tier }); inst.close(); return; }
      if ((b = t.closest('[data-kr-gift]'))) {
        e.preventDefault();
        if (typeof inst._swapBundleGift === 'function') inst._swapBundleGift(b.getAttribute('data-kr-gift-key'), b.getAttribute('data-kr-gift'), b);
        return;
      }
      if (t.closest('[data-kr-remove]')) { if (typeof inst._removeBundle === 'function') inst._removeBundle(h.bundle.id); return; }
    });
  }

  /* kit:i a design (onSwap opens our strip on it, if it can be swapped) · acc:i view only ·
     swap:i a strip tile (price + "Swap for this design") · up:i a kit-price tile (price + "Add at £x").
     The actions re-find their tile by handle when they run (the row may have re-rendered). */
  function openQv(inst, h, st, spec, trigger) {
    var Q = window.HGN && window.HGN.quickView;
    if (!Q || typeof Q.open !== 'function') return;
    var p = String(spec).split(':'), kind = p[0], i = parseInt(p[1], 10) || 0;
    var o = { context: 'bag', trigger: trigger }, handle = '', why = kind;
    var at = function (list, hd) { var k = -1; (list || []).forEach(function (x, j) { if (k < 0 && (x.handle || (x.item && x.item.handle)) === hd) k = j; }); return k; };
    if (kind === 'kit') {
      var it = h.designs[i];
      if (!it) return;
      handle = it.handle;
      if (swappable(it)) o.onSwap = function () { st.userScroll = true; goSlide(st, i + 1, true); if (!st.swap || st.swap.key !== it.key) openSwap(inst, st.hero || h, st, it.key); };
    } else if (kind === 'acc') {
      handle = h.extras[i] ? h.extras[i].it.handle : '';
      why = 'accessory';
    } else if (kind === 'swap') {
      var s = st.swap, d = s && s.list && s.list[i];
      if (!d) return;
      handle = d.handle;
      o.price = { text: 'Same kit price', note: 'Swaps into your kit at no extra cost' };
      if (!(s.gone && s.gone[i]) && s.busy == null && !st.swapBusy) o.action = { label: 'Swap for this design', onClick: function () { var k = st.swap ? at(st.swap.list, handle) : -1; if (k >= 0) doSwap(inst, st.hero || h, st, k, 'qv'); } };
    } else if (kind === 'up') {
      var m = st.upsell && st.upsell.model, c = m && m.cands && m.cands[i];
      if (!c) return;
      handle = c.item.handle;
      why = 'upsell';
      var pr = money(c.pairPres, h.cur);
      o.price = { text: pr, was: c.retailPres ? money(c.retailPres, h.cur) : '', note: 'Your kit price' };
      if (!st.upInflight) o.action = { label: 'Add at ' + pr, onClick: function () { var mm = st.upsell && st.upsell.model, k = mm ? at(mm.cands, handle) : -1; if (k >= 0) addUpsell(inst, st.hero || h, st, k, null, 'qv'); } };
    }
    if (!handle) return;
    offer('qv', { tier: h.tier, reason: why });
    try { Q.open(handle, o); } catch (x) { warn(x); }
  }
  function addUpsell(inst, h, st, i, btn, via) {
    var model = st.upsell && st.upsell.model;
    var c = model && model.cands && model.cands[i];
    if (!c || st.upInflight) return;
    st.upInflight = true;
    var all = st.blocks.up ? st.blocks.up.querySelectorAll('[data-kr-up]') : [];
    for (var k = 0; k < all.length; k++) all[k].disabled = true;
    if (btn) btn.classList.add('is-busy');
    var cur = h.cart.currency, d = c.item;
    var props = {};
    props._hgn_src = 'checkout_pair:' + h.tier + ':' + (d.source || 'viewed') + ':kitready';
    props._hgn_offer_kind = 'pair';
    props._hgn_offer_gbp_cents = String(c.saveGbp);
    props._hgn_offer_pres_cents = String(c.savePres);
    props._hgn_offer_pair_pres = String(c.pairPres);
    props._hgn_offer_label = 'Kit price ' + money(c.pairPres, cur);
    postJson('/cart/add.js', { items: [{ id: parseInt(d.variantId, 10), quantity: 1, properties: props }] }).then(function (r) {
      st.upInflight = false;
      if (!r.ok) {
        /* sold out since the row was built (4xx): that tile goes, the rest stay */
        if (model.cands) model.cands.splice(i, 1);
        if (!model.cands.length) model.state = 'none';
        if (st.blocks.up) st.blocks.up.__krHtml = null;
        return inst.refresh();
      }
      offer('upsell_add', { tier: h.tier, reason: via || d.source || '', source: d.source || '' });
      try { document.dispatchEvent(new CustomEvent('hgn:attach:add', { detail: { reason: 'kitready_pair', slot: h.tier, variantId: d.variantId, handle: d.handle } })); } catch (e) {}
      return inst.refresh();
    }).catch(function (e) { st.upInflight = false; warn(e); });
  }

  /* ── The drawer foot (B, a kit in the bag) ─────────────────────────── */
  function syncFoot(inst, h) {
    var foot = inst.footEl;
    if (!foot) return;
    if (!h || foot.hidden) { clearFoot(inst); return; }
    foot.classList.add('hgn-side-cart__foot--kr');
    var sum = foot.querySelector('[data-hgn-kr-foot]');
    if (!sum) {
      sum = el('div', 'hgn-kr-foot', { 'data-hgn-kr-foot': '' });
      sum.innerHTML = '<div class="hgn-kr-foot__l"><p class="hgn-kr-foot__label">Bag total</p><p class="hgn-kr-foot__save" data-kr-foot-save></p></div><p class="hgn-kr-foot__total" data-kr-foot-total></p>';
      foot.insertBefore(sum, foot.firstChild);
    }
    var kit = h.deal.save, cur = h.cur;
    var totalSave = 0;
    try { totalSave = (inst._lastSavingsCents || 0) + kit5Cents(inst); } catch (e) {}
    var shown = inst.savingsEl && !inst.savingsEl.hidden && inst.savingsValueEl ? String(inst.savingsValueEl.textContent || '').trim() : '';
    var save = '';
    if (kit > 0 && Math.abs(totalSave - kit) <= 1) save = 'Kit saving ' + money(kit, cur);
    /* the card's "You save" is the kit's alone; the foot names its own figure (Matt, 21 Oct) */
    else if (shown) save = 'Total saving ' + shown;
    var saveEl = sum.querySelector('[data-kr-foot-save]');
    var totEl = sum.querySelector('[data-kr-foot-total]');
    if (saveEl.textContent !== save) saveEl.textContent = save;
    saveEl.hidden = !save;
    var tot = inst.subtotalEl ? inst.subtotalEl.textContent : '';
    if (totEl.textContent !== tot) totEl.textContent = tot;
    syncPay(inst);
  }
  /* Express is the primary action when its entry is up (arm B of `express`, a qualifying
     basket, Shopify's wallets rendered); otherwise Checkout stays the button it is today. */
  function syncPay(inst) {
    var foot = inst.footEl;
    if (!foot || !foot.classList.contains('hgn-side-cart__foot--kr')) return;
    var entry = foot.querySelector('[data-hgn-express-entry]');
    var pay = !!(entry && !entry.hidden && entry.classList.contains('has-marks')) && !inst._checkoutMintFailed;
    foot.classList.toggle('hgn-side-cart__foot--kr-pay', pay);
  }
  function clearFoot(inst) {
    var foot = inst.footEl;
    if (!foot) return;
    foot.classList.remove('hgn-side-cart__foot--kr', 'hgn-side-cart__foot--kr-pay');
    var sum = foot.querySelector('[data-hgn-kr-foot]');
    if (sum && sum.parentNode) sum.parentNode.removeChild(sum);
  }
  var footWired = false;
  function wireFoot(inst) {
    if (footWired || !inst.footEl) return;
    footWired = true;
    var foot = inst.footEl;
    /* Capture phase on the foot: the wallet tap goes through HGN.express.openFrom('kitready')
       (the same panel, tagged with this surface); the Checkout tap is only counted. */
    foot.addEventListener('click', function (e) {
      if (!foot.classList.contains('hgn-side-cart__foot--kr')) return;
      var t = e.target && e.target.closest ? e.target : null;
      if (!t) return;
      var h = stateOf(inst).hero;
      if (t.closest('[data-hgn-side-cart-checkout]')) { offer('checkout_tap', { tier: h ? h.tier : '' }); return; }
      var btn = t.closest('[data-hgn-express-open]');
      if (!btn || !foot.classList.contains('hgn-side-cart__foot--kr-pay')) return;
      var X = window.HGN && window.HGN.express;
      if (!X || typeof X.openFrom !== 'function') return;
      e.preventDefault();
      e.stopPropagation();
      var wallet = 'any';
      try {
        var marks = btn.querySelectorAll('[data-hgn-express-mark]');
        for (var i = 0; i < marks.length; i++) {
          if (marks[i].hidden) continue;
          var r = marks[i].getBoundingClientRect();
          if (e.clientX >= r.left && e.clientX <= r.right && e.clientY >= r.top && e.clientY <= r.bottom) wallet = marks[i].getAttribute('data-hgn-express-mark');
        }
      } catch (x) {}
      offer('pay_tap', { tier: h ? h.tier : '', wallet: wallet, reason: wallet });
      X.openFrom('kitready');
    }, true);
    document.addEventListener('hgn:express:state', function () { try { syncPay(inst); } catch (e) {} });
    if (typeof window.MutationObserver === 'function') {
      try {
        var entry = foot.querySelector('[data-hgn-express-entry]');
        if (entry) new MutationObserver(function () { syncPay(inst); }).observe(entry, { attributes: true, attributeFilter: ['hidden', 'class'] });
      } catch (e) {}
    }
  }

  /* ── The pass ──────────────────────────────────────────────────────── */
  function teardown(inst) {
    var st = inst._kr;
    if (!st) return;
    if (st.host && st.host.parentNode) st.host.parentNode.removeChild(st.host);
    st.host = null; st.blocks = {}; st.built = false; st.hero = null; st.bid = ''; st.swap = null;
    clearFoot(inst);
    clearBag(inst);
  }
  /* One composed bag (Matt, 21 Oct): the hero owns its kit, so that kit's own line card is taken
     out of the freshly painted lines (this runs in the same task as the paint — nothing flashes);
     the rest of the bag sits under an "Also in your bag" eyebrow on the card's gutters (CSS,
     .hgn-side-cart__cart-section--kr). Other kits keep today's card. */
  function composeBag(inst, h) {
    var items = inst.itemsEl, sec = inst.cartSectionEl;
    if (!items) return;
    var lines = 0;
    var giftName = '';
    try { var gt = inst.config.gift.tiers[0]; giftName = (gt && (gt.friendlyName || gt.title)) || ''; } catch (e) {}
    Array.prototype.slice.call(items.children).forEach(function (n) {
      var card = n.hasAttribute('data-hgn-side-cart-bundle-card');
      if (card && n.getAttribute('data-hgn-bundle-id') === h.bundle.id) { items.removeChild(n); return; }
      if (card || n.classList.contains('hgn-side-cart__item')) lines++;
      /* the free gift by the name the meter gives it ("Crystal Nail File"), full title kept */
      var gl = n.classList.contains('hgn-side-cart__item--gift') && n.querySelector('.hgn-side-cart__item-title');
      if (gl && !gl.hasAttribute('data-hgn-kr-name')) {
        var full = gl.textContent;
        gl.setAttribute('data-hgn-kr-name', '');
        gl.setAttribute('title', full);
        gl.textContent = giftName || accName(full);
      }
    });
    /* body flag: the attach row's design bridge stands down under the hero (CSS) — the card's
       kit-price row already offers the tier's designs, at kit price; one design, one price */
    if (inst.body) inst.body.classList.add('hgn-side-cart__body--kr');
    if (!sec) return;
    sec.classList.add('hgn-side-cart__cart-section--kr');
    sec.classList.toggle('hgn-side-cart__cart-section--kr-empty', !items.children.length);
    var head = sec.querySelector('[data-hgn-kr-also]');
    if (!head) {
      head = el('p', 'hgn-kr-also', { 'data-hgn-kr-also': '' });
      sec.insertBefore(head, sec.firstChild);
    }
    var txt = 'Also in your ' + bagWord();
    if (head.textContent !== txt) head.textContent = txt;
    head.hidden = !lines;
  }
  function clearBag(inst) {
    if (inst.body) inst.body.classList.remove('hgn-side-cart__body--kr');
    var sec = inst.cartSectionEl;
    if (!sec) return;
    sec.classList.remove('hgn-side-cart__cart-section--kr', 'hgn-side-cart__cart-section--kr-empty');
    var head = sec.querySelector('[data-hgn-kr-also]');
    if (head && head.parentNode) head.parentNode.removeChild(head);
  }
  function sync(inst) {
    if (!inst || !inst.cart) return;
    var b = isB();
    if (!b) {
      /* arm A: landings only (the both-arm `eligible`), the DOM is never touched */
      try { if (inst.cart.item_count && typeof H.groupCartLines === 'function') noteBundles(H.groupCartLines((inst.cart.items || []).slice()).bundles.filter(function (x) { return x.tier; })); } catch (e) {}
      teardown(inst);
      return;
    }
    var st = stateOf(inst);
    var h = pickHero(inst);
    if (!h || !inst.body) { teardown(inst); return; }
    wireFoot(inst);
    ensureHost(inst, st);
    if (st.bid !== h.bundle.id) { st.swap = null; st.upsell = null; st.slide = 0; st.userScroll = false; }
    st.hero = h; st.tier = h.tier;
    if (!st.built || st.skin !== h.skin || st.bid !== h.bundle.id) {
      buildFull(st, h);
      st.built = true; st.skin = h.skin; st.bid = h.bundle.id;
    }
    var name = heroName(h);
    var nameEl = st.host.querySelector('[data-kr-name]');
    /* balanced wrapping (CSS) never splits "Press-On" at its hyphen */
    if (nameEl && nameEl.textContent !== name) nameEl.innerHTML = esc(name).replace(/Press-On/g, '<span class="hgn-kr__nb">Press-On</span>');
    var sub = heroSub(h);
    var subEl = st.host.querySelector('[data-kr-sub]');
    if (subEl && subEl.textContent !== sub) { subEl.textContent = sub; subEl.hidden = !sub; }
    var fk = focusKey(st);
    var r = railHtml(h, st);
    var rail = st.blocks.rail;
    var keep = rail.scrollLeft;
    if (setBlock(st, 'track', r.rail)) {
      hydrate(rail);
      st.blocks.thumbs.__krHtml = '';
      var fx = st.swapFx && Date.now() - st.swapFx.at < 4000 ? st.swapFx : null;
      if (fx) {
        var at = 0;
        h.designs.forEach(function (it, i) { if (String(it.variant_id) === fx.vid) at = i + 1; });
        rail.scrollLeft = 0;
        goSlide(st, at, false);
        st.swapFx = null;
      } else {
        rail.scrollLeft = keep;
      }
    }
    setBlock(st, 'thumbs', r.thumbs.replace(/data-kr-thumb="(\d+)"/g, 'data-kr-thumb="$1" style="--t:$1"'));
    st.slide = syncNav(st);
    if (st.swap && !h.designs.some(function (it) { return it.key === st.swap.key; })) st.swap = null;
    paintSwap(inst, h, st);
    paintRailState(st);
    refocus(st, fk);
    var flash = st.flash ? '<span class="hgn-kr__flash-in">' + CHECK + esc(st.flash) + '</span>' : '';
    if (setBlock(st, 'flash', flash) && st.flash) {
      var mineF = st.flash;
      setTimeout(function () { if (st.flash === mineF) { st.flash = ''; setBlock(st, 'flash', ''); } }, 2600);
    }
    setBlock(st, 'rcpt', receiptHtml(h));
    setBlock(st, 'gift', giftRowHtml(h));
    if (inst.isOpen) resolveUpsell(inst, h, st);
    var up = upsellModel(inst, h, st);
    setBlock(st, 'up', upsellHtml(inst, h, up));
    var said = up.state === 'added' ? 'Added ' + up.name + (up.price ? ' at ' + up.price : '') : '';
    if (st.blocks.say && st.blocks.say.textContent !== said) st.blocks.say.textContent = said;
    if (up.state === 'offer' && inst.isOpen) offerOnce('up:' + st.upsell.sig, 'upsell_shown', { tier: h.tier, reason: String(up.cands.length) });
    /* one offer, in the card: the pair card / row stands down while the hero is up */
    try { if (inst._pairOfferOpen && typeof inst._hidePairOffer === 'function') inst._hidePairOffer(); } catch (e) {}
    if (inst.isOpen) offerOnce('shown:' + h.bundle.id, 'shown', { tier: h.tier, how: h.how, edit: h.edit ? h.edit.slug : null, reason: h.how, surface: h.edit ? h.edit.slug : '' });
    composeBag(inst, h);
    syncFoot(inst, h);
    if (inst.isOpen) maybeReveal(inst, st, h);
  }
  /* Where keyboard focus sits in the parts a render rebuilds, so it can be put back (a swap
     rebuilds the rail and thumbs and closes the strip under the focused tile). */
  function focusKey(st) {
    var a = document.activeElement, b = st.blocks;
    if (st.refocus) { var r0 = st.refocus; st.refocus = null; return r0; }
    if (!a || !st.host || !st.host.contains(a)) return null;
    var t = a.closest && a.closest('[data-kr-thumb]');
    if (t && b.thumbs && b.thumbs.contains(t)) return { t: t.getAttribute('data-kr-thumb') };
    var sl = a.closest && a.closest('.hgn-kr__slide');
    if (sl && b.track && b.track.contains(sl)) return { s: parseInt(sl.getAttribute('data-kr-slide'), 10) || 0, pill: !!a.closest('.hgn-kr__swap-pill') };
    return null;
  }
  function refocus(st, fk) {
    if (!fk || !st.host) return;
    var a = document.activeElement;
    if (a && a !== document.body && a.isConnected && st.host.contains(a) && !(st.blocks.swap && st.blocks.swap.contains(a))) return;
    var target = null;
    if (fk.t != null && st.blocks.thumbs) target = st.blocks.thumbs.querySelector('[data-kr-thumb="' + fk.t + '"]');
    else if (fk.s != null && st.blocks.track) {
      var sl = st.blocks.track.querySelector('.hgn-kr__slide[data-kr-slide="' + fk.s + '"]');
      target = sl && (fk.pill ? sl.querySelector('.hgn-kr__swap-pill') : null) || (sl && sl.querySelector('.hgn-kr__media'));
    }
    if (target) { try { target.removeAttribute('tabindex'); target.focus({ preventScroll: true }); } catch (e) {} }
  }
  function hydrate(root) {
    try { if (window.HGN && typeof window.HGN.kitCollageHydrate === 'function' && root.querySelector('[data-hgn-bundle-collage]')) window.HGN.kitCollageHydrate(root); } catch (e) {}
  }
  var queued = false;
  function schedule(inst) {
    wrapOffer();
    if (queued) return;
    queued = true;
    /* A microtask: runs after every sibling's _render wrapper (attach, referral, express and
       anything later) has painted the foot and the lines, so the card reads final figures. */
    Promise.resolve().then(function () {
      queued = false;
      try { sync(inst); } catch (e) { warn(e); }
    });
  }

  /* ── Hooks ─────────────────────────────────────────────────────────── */
  var origRender = P._render;
  P._render = function () {
    var out = origRender.apply(this, arguments);
    try { schedule(this); } catch (e) {}
    return out;
  };
  /* Asked by the attach row before it resolves its design bridge (hgn-side-cart-attach.js): in B,
     while a hero kit is up, the card's kit-price row is the design offer, so the bridge design is
     never looked up, drawn or counted. Mirrors pickHero's own gate, without writing anything. */
  P._kitReadyHeroUp = function () {
    try {
      if (!isB() || !this.cart || !this.cart.item_count || typeof H.groupCartLines !== 'function' || intentNailPoints(this)) return false;
      return H.groupCartLines((this.cart.items || []).slice()).bundles.some(function (b) { return b.tier && b.items.length; });
    } catch (e) { return false; }
  };
  /* Settle-on-open lands on the hero (hgn-side-cart.js justAddedEl). */
  P._kitReadyHeroFor = function (bid) {
    var st = this._kr;
    if (!st || !st.host || !st.host.isConnected || !st.hero || st.hero.bundle.id !== bid) return null;
    return st.host;
  };
  /* While the hero is up, the pair offer belongs to the card. Wrapped on first use: the
     attach file loads after this one. */
  var offerWrapped = false;
  function wrapOffer() {
    if (offerWrapped || typeof P._maybeShowOffer !== 'function') return;
    offerWrapped = true;
    var orig = P._maybeShowOffer;
    P._maybeShowOffer = function () {
      var st = this._kr;
      if (st && st.host && st.hero && isB()) {
        try { if (this._pairOfferOpen) this._hidePairOffer(); } catch (e) {}
        return;
      }
      return orig.apply(this, arguments);
    };
  }
  var origClose = P.close;
  P.close = function () {
    var st = this._kr;
    if (st) {
      st.swap = null; st.userScroll = false;
      if (st.motion === 'pending') endPre(st);
      else if (st.revealTimers) finishReveal(this, st, false);
    }
    return origClose.apply(this, arguments);
  };
  window.HGN.kitReady = {
    arm: arm,
    isB: isB,
    off: off,
    /* harness / console */
    state: function () {
      var inst = window.HGN.sideCart && typeof window.HGN.express === 'object' && window.HGN.express._instance ? window.HGN.express._instance() : null;
      var st = inst && inst._kr;
      return { arm: arm(), off: off(), hero: !!(st && st.host), bundle: st ? st.bid : '', swap: !!(st && st.swap), upsell: st && st.upsell ? st.upsell.model.state : null,
        motion: st && st.motion ? st.motion : 'idle', reveals: counts.reveals, nudges: counts.nudges, skips: counts.skips };
    }
  };
})();
